"use strict";
(function () {

    function validationStatusIconDirective() {

        function getColor(valid) {
            return valid ? "green" : "red";
        }

        function getIcon(valid) {
            return "/dist/images/" + (valid ? "icon-verify.svg" : "icon-error.svg");
        }

        function validatorsEmpty(control) {
            for (var prop in control.$validators) {
                //if (control.$validators.hasOwnProperty(prop) && prop !== "required") {
                if (control.$validators.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return true;
        }


        return {
            restrict: "E",
            scope: {
                control: "=ngControl",
                form: "=?"
            },
            controller: ['$scope', function ($scope) {
                var ctrl = this;
                ctrl.getColor = getColor;
                ctrl.getIcon = getIcon;
                ctrl.show = function (control, form) {
                    if (typeof (control) === "undefined" || control === null) { return false; }

                    form = form || control.$$parentForm;

                    if (control.$isEmpty(control.$viewValue) || control.$isEmpty(control.$modelValue)) {
                        control.$required = control.$error.required;
                    }

                    if (!control.$touched) {
                        return false;
                    }
                    if (control.$required) return true;


                    //if (control.$error.required ||
                    //    control.$error.pattern ||
                    //    control.$error.date ||
                    //    control.$error.time ||
                    //    control.$error.min ||
                    //    control.$error.max) {
                    //    return true;
                    //}
                    //return control.$invalid;
                    return !validatorsEmpty(control);
                };
            }],
            controllerAs: "ctrl",
            template: [
                "<img ng-show=\"ctrl.show(control, form)\" class=\"icon validation-status-icon\" ng-src=\"{{ctrl.getIcon(control.$valid)}}\" ng-style=\"{'color': ctrl.getColor(control.$valid)}\" style=\"position: absolute; top: 50%;margin-top:-12px; right: 8px; color:grey;\" />",
            ].join()
        };
    }

    var app = angular.module("dnapp");
    app.directive("validationStatusIcon", [validationStatusIconDirective]);
})();